import { render, staticRenderFns } from "./SellerInfonew.vue?vue&type=template&id=35a408dc&scoped=true"
import script from "./SellerInfonew.vue?vue&type=script&lang=js"
export * from "./SellerInfonew.vue?vue&type=script&lang=js"
import style0 from "./SellerInfonew.vue?vue&type=style&index=0&id=35a408dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a408dc",
  null
  
)

export default component.exports